import { Collapse } from "@material-ui/core";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import React from "react";

export const DetailsSection = ({
  id,
  title,
  icon,
  children,
  expanded,
  setExpanded,
}) => {
  const handleClick = () => {
    if (expanded === id) {
      setExpanded(0);
    } else {
      setExpanded(id);
    }
  };
  return (
    <div className="tw-rounded-[12px] tw-border tw-border-[#ccc3fa] tw-bg-white tw-shadow-[0px_3px_1px_0px_rgba(0,0,0,0.12)]">
      <div
        className="tw-flex tw-items-center tw-justify-start tw-gap-2 tw-py-[16px] tw-px-[8px] tw-pl-[12px] tw-gap-[8px] tw-cursor-pointer tw-select-none"
        onClick={handleClick}
      >
        <div className="tw-bg-[#EFEDFC] tw-rounded-xl tw-flex tw-justify-center tw-items-center tw-p-2">
          <ExlyImage src={icon} alt="FAQ Icon" />
        </div>
        <div className="tw-font-medium tw-text-[1rem] tw-leading-normal tw-text-[#272522]">
          {title}
        </div>

        <ArrowDropDownRoundedIcon
          className={expanded === id ? "[transform:rotate(180deg)]" : ""}
        />
      </div>

      <Collapse in={expanded === id}>
        <div className="tw-border-t-2 tw-border-solid tw-border-0 tw-border-t-[#e7e6e4] tw-px-[24px] tw-py-[12px]">
          {children}
        </div>
      </Collapse>
    </div>
  );
};
